import React from 'react'
import QRScannerModal from '../../Modals/QRScannerModal'
import AssemblySearchResultsModal from '../../Modals/AssemblySearchResultsModal'
import AssemblyIDSearchModal from '../../Modals/AssemblyIDSearchModal'
import { FormMenu } from './FormMenu'
import {
    LockModal,
    Sticky,
    StickyContainer,
} from '../../../../GlobalComponents/awc-reactjs-components'
import FormNotification from '../../../widget/Components/FormNotification'
import { PONumberSearchModal } from '../../Modals/POSearchModal'
const renderSaveButton = (
    lockState,
    recordLockLevel,
    disableSubmits,
    formOrError,
    onSubmit,
    data,
    setSaveButtonRendered
) => {
    // save buttons are disabled as soon as one is clicked to prevent multiple saves
    return !lockState.locked && recordLockLevel !== -1 ? (
        <button
            style={{ position: 'absolute', top: 5, left: 20 }}
            className='btn btn-success'
            type='submit'
            key='save'
            disabled={disableSubmits || formOrError !== 'form'}
            onClick={(e) => {
                onSubmit(e)

                if (data) {
                    if (data.Form && data.Form.length > 0) {
                        if (data.Form[0].Purpose.trim().toUpperCase() === 'PERFORMANCE REVIEW') {
                            setSaveButtonRendered(false)
                        } else {
                            setSaveButtonRendered(true)
                        }
                    } else {
                        if (data.Form.Purpose.trim().toUpperCase() !== 'PERFORMANCE REVIEW') {
                            setSaveButtonRendered(false)
                        } else {
                            setSaveButtonRendered(true)
                        }
                    }
                }
            }}
        >
            <span key='saveGlyph' className='glyphicon glyphicon-floppy-disk' />
            &nbsp;Save Form
        </button>
    ) : null
}

export const FormHeader = (
    form,
    version,
    data,
    setFormViewId,
    //handlePrint,
    recordId,
    formId,
    toggleMenu,
    closeMenu,
    lockState,
    numLevels,
    setCurrentModal,
    lockedLevelsArray,
    recordLockLevel,
    refRecordId,
    isMenuOpen,
    isQRModalVisible,
    handleQRCloseModal,
    handleScanComplete,
    setAssemblyError,
    isAssemblySearchModalVisible,
    handleAssemblyResultsCloseModal,
    apiData,
    handleAssemblySearchConfirm,
    isAssemblyModalVisible,
    handleAssemblyCloseModal,
    assemblyError,
    saveButtonRendered,
    fieldChanged,
    showVersionOutOfDateAlert,
    assemblyInfo,
    saving,
    savedTime,
    setSaveButtonRendered,
    disableSubmits,
    formOrError,
    onSubmit,
    currentUser,
    versionNumber,
    handleSign,
    lockedLevels,
    setAssemblyInfo,
    handleReadOnly,
    isPOModalVisible,
    handlePOCloseModal,
    handlePOComplete,
    canUnlock,
    setShowConfirmModal
) => {
    let header_children = []
    const notificationType = {
        error: assemblyError ? true : false,
        success: assemblyInfo ? true : false,
    }

    const closeInfoNotification = () => {
        setAssemblyInfo('')
    }

    const closeErrorNotification = () => {
        setAssemblyError('')
    }
    header_children.push(
        React.createElement(QRScannerModal, {
            key: 'qrScannerModal',
            isVisible: isQRModalVisible,
            onClose: handleQRCloseModal,
            onScanComplete: (uValue) => handleScanComplete(uValue),
            setError: setAssemblyError,
        })
    )
    header_children.push(
        React.createElement(PONumberSearchModal, {
            key: 'poNumberSearchModal',
            isVisible: isPOModalVisible,
            onClose: handlePOCloseModal,
            awcidSearchWithPo: (uValue) => handlePOComplete(uValue),
        })
    )
    header_children.push(
        React.createElement(AssemblySearchResultsModal, {
            key: 'assemblySearchResultsModal',
            isVisible: isAssemblySearchModalVisible,
            onClose: handleAssemblyResultsCloseModal,
            AssemblyProps: apiData,
            handleConfirm: handleAssemblySearchConfirm,
        })
    )
    header_children.push(
        React.createElement(AssemblyIDSearchModal, {
            key: 'assemblySearchModal',
            isVisible: isAssemblyModalVisible,
            onClose: handleAssemblyCloseModal,
            handleAssemblyIDSearch: handleScanComplete,
        })
    )
    header_children.push(
        FormMenu(
            data,
            setFormViewId,
            //handlePrint,
            recordId,
            formId,
            toggleMenu,
            closeMenu,
            lockState,
            numLevels,
            setCurrentModal,
            lockedLevelsArray,
            recordLockLevel,
            refRecordId,
            isMenuOpen,
            fieldChanged,
            currentUser,
            versionNumber,
            handleSign,
            lockedLevels,
            handleReadOnly,
            canUnlock,
            setShowConfirmModal
        )
    )
    header_children.push(
        React.createElement(
            'h3',
            {
                key: 'h3',
                style: {
                    display: 'inline-block',
                    margin: 'auto',
                },
            },
            form
        )
    )
    header_children.push(
        React.createElement(
            'h5',
            {
                key: 'h5',
            },
            version
        )
    )
    header_children.push(
        React.createElement('hr', {
            key: 'hr1',
            style: {
                marginTop: '2rem',
                marginBottom: '1rem',
                border: 0,
                borderTop: '1px solid rgba(0, 0, 0, .1)',
            },
        })
    )

    return (
        <Sticky key={'stickyHeader'}>
            {({ style }) => (
                <div
                    style={{
                        ...style,
                        backgroundColor: 'white',
                        paddingTop: version ? '0px' : '20px',
                        textAlign: 'center',
                        zIndex: 2,
                    }}
                >
                    <div
                        className='alert alert-warning'
                        role='alert'
                        style={{
                            textAlign: 'left',
                            display: showVersionOutOfDateAlert ? '' : 'none',
                        }}
                    >
                        System updates pending. Please save your form and refresh
                        <div
                            onClick={() => window.location.reload(true)}
                            className='pull-right btn btn-link no-padding'
                        >
                            REFRESH
                        </div>
                    </div>
                    <div
                        className='alert alert-danger'
                        role='alert'
                        style={{
                            textAlign: 'left',
                            display: lockState.locked ? '' : 'none',
                        }}
                    >
                        {lockState.lockedBy
                            ? `Currently being edited by ${lockState.lockedBy}. You are in read-only mode`
                            : 'READ ONLY MODE'}
                    </div>
                    <div>
                        {assemblyError && (
                            <FormNotification
                                formNotificationType={notificationType}
                                text={assemblyError}
                                onClose={closeErrorNotification}
                            />
                        )}
                    </div>
                    <div>
                        {assemblyInfo && (
                            <FormNotification
                                formNotificationType={notificationType}
                                text={assemblyInfo}
                                onClose={closeInfoNotification}
                            />
                        )}
                    </div>
                    {saveButtonRendered &&
                        renderSaveButton(
                            lockState,
                            recordLockLevel,
                            disableSubmits,
                            formOrError,
                            onSubmit,
                            data,
                            setSaveButtonRendered
                        )}
                    {data &&
                        (saving ? (
                            <div style={{ position: 'absolute', top: 70 }}>
                                Saving...{' '}
                                <div className={'k-i-loading'} style={{ left: 40, bottom: 10 }} />
                            </div>
                        ) : (
                            savedTime && (
                                <div style={{ position: 'absolute', top: 70 }}>
                                    Last Saved on {savedTime} CST
                                </div>
                            )
                        ))}
                    {header_children}
                </div>
            )}
        </Sticky>
    )
}
